import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const Search = ({ className, ...rest }) => (_jsx("input", { type: "text", className: classNames("cvr-search", className), ...rest }));
